import { CatButton, CatHeading } from 'components/blocks-components';
import styles from './generic-error.module.scss';
import React, { useEffect, useState } from 'react';
import {
  getCATLogoUrl,
  getDealerUrl,
  getGlobalErrorKeys
} from 'services/translations/action';
import { Image } from 'components/image';
import {
  CATCORP_LOGO_ALT_TEXT,
  LOGO_SIZES
} from '@cat-ecom/pcc-components/src/components/header/constants';
import { useParams } from 'next/navigation';
import { CATCORP_ESITE } from 'constants/common';

const GenericError = () => {
  const [keys, setKeys] = useState({});
  const [dealerUrl, setDealerUrl] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [logoSizes, setLogoSizes] = useState(LOGO_SIZES?.catLogo);
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const params = useParams();

  useEffect(() => {
    const getTranslationKeys = async () => {
      const catLogoUrl = await getCATLogoUrl();
      const isCatCorp = params.esite === CATCORP_ESITE;
      const isCatImage = (catLogoUrl ?? '').includes('catcorp');
      setLogoSizes(
        isCatCorp || isCatImage ? LOGO_SIZES.catLogo : LOGO_SIZES.dealerLogo
      );
      setLogoUrl(catLogoUrl);
      const t = await getGlobalErrorKeys();
      setKeys(t);
      const url = await getDealerUrl();
      setDealerUrl(url);
    };

    getTranslationKeys();
  }, [params?.esite]);
  return (
    <div
      className={`w-100 d-flex flex-column align-items-center justify-content-between vh-100`}
    >
      <div
        className={`w-100 d-flex align-items-center justify-content-center ${styles['header-footer']}`}
      >
        <Image
          alt={CATCORP_LOGO_ALT_TEXT}
          aria-label={CATCORP_LOGO_ALT_TEXT}
          src={logoUrl}
          height={logoSizes?.height}
          width={logoSizes?.width}
        />
      </div>
      <div className="text-center mx-4">
        <CatHeading variant={'display-lg'} level="h1">
          {keys['UNEXPECTED_ERROR_TITLE']}
        </CatHeading>
        <p className="cat-u-theme-typography-body-sm my-4">
          {keys['UNEXPECTED_ERROR_MESSAGE']}
        </p>
        <div>
          <CatButton size="lg" variant="primary" href={dealerUrl}>
            <p className="mb-0">{keys['VISIT_PCC']}</p>
          </CatButton>
        </div>
      </div>
      <div className={`w-100 ${styles['header-footer']}`} />
    </div>
  );
};

export default GenericError;
